module.exports = __webpack_public_path__ + "static/media/image_31.acb14ef1.png";